import './css/RoomStatus.css'

import { useState } from "react"
import { Input, Button, Select, DatePicker, message, Space } from 'antd'
import { SearchOutlined, RedoOutlined } from '@ant-design/icons'
import { axiosTable, baseAxiosNoInfo } from "../../tool/axios"
import { SelectStores } from "../../component/common/Selects"
import BreadCrumb from '../../component/BreadCrumb'
import moment from "moment"
import _ from 'lodash'

const { Option } = Select
const { RangePicker } = DatePicker

type fetchParams = {
    store_id: undefined | string,
    date: any,
    check_in_user_name: string | undefined,
    check_in_phone: string | undefined,
    room_type_id: string | undefined,
    room_number: string | undefined,
    floor: number | undefined,
    direction: number | undefined,
    minion_id: string | undefined
}

interface ep {
    "employee_id": string,
    "user_name": string
}

interface room {
    "room_id": string // 房间id
    "room_number": string // 房间号
    "room_type_id": string // 房型id
    "room_type_name": string // 房型名称
    "room_status": number // 房间状态
    "can_reserve_days": number
    "check_in_id": string
    "check_in_user_name": string
    "check_in_start_day": string
    "check_in_end_day": string
    "check_in_total_days": number
    "check_in_already_days": number
    "check_in_left_days": number
    "belong_minion_id": string
    "belong_minion_name": string
}

export default function () {

    let fetchOtherParamsTmpl: fetchParams = {
        store_id: undefined,
        date: null,
        check_in_user_name: undefined,
        check_in_phone: undefined,
        room_type_id: undefined,
        room_number: undefined,
        floor: undefined,
        direction: undefined,
        minion_id: undefined
    }

    const [roomTypeList, setRoomTypeList] = useState<{ room_type_id: string, room_type_name: string }[]>([])
    const [roomWays, setRoomWays] = useState<{ direction: string | number, direction_name: any }[]>([])

    const [fetchOtherParams, setFetchOtherParams] = useState<fetchParams>(fetchOtherParamsTmpl)

    // 门店房态图
    // 构造房态图的日期表头
    const [columnsList, setColumnsList] = useState([])

    // 获取住房信息
    const [roomStateData, setRoomStateData] = useState([])

    const handleChange = (value: any, attr: string) => {
        let params: any = _.cloneDeep(fetchOtherParams)
        params[attr] = value

        setFetchOtherParams(params)
    }

    const handleSearch2 = () => {
        fetch2({ fetchOtherParams })
    }

    // 验证当前相距的月份数
    const getDistanceMonth = (startTime: any, endTime: any) => {
        startTime = new Date(startTime)
        endTime = new Date(endTime)

        let dateToMonth = 0
        const startDate = startTime.getDate() + startTime.getHours() / 24 + startTime.getMinutes() / 24 / 60
        const endDate = endTime.getDate() + endTime.getHours() / 24 + endTime.getMinutes() / 24 / 60

        if (endDate >= startDate) {
            dateToMonth = 0

        } else {
            dateToMonth = -1
        }

        const yearToMonth = (endTime.getYear() - startTime.getYear()) * 12
        const monthToMonth = endTime.getMonth() - startTime.getMonth()

        return yearToMonth + monthToMonth + dateToMonth + 1
    }

    const fetch2 = ({ fetchOtherParams }: { fetchOtherParams: object }) => {

        let params: any = { ...fetchOtherParams }

        if (!params.store_id) {
            return message.error('请选择要查询的门店')
        }

        if (params.date) {
            params.date = moment(params.date[0]).format('YYYY-MM')

        } else {
            return message.error('请选择要查询的月份时间')
        }

        axiosTable.get('/keeper/check_in/new_store_room_situation', {
            params: {
                ...params
            }

        }).then((response: any) => {
            if (response) {
                const { date_list, room_situation_data } = response
                const room_type_list: any = room_situation_data.room_type_list

                setColumnsList(date_list)

                if (room_type_list && room_type_list.length > 0) {
                    let typeList = room_type_list

                    for (let i = 0; i < typeList.length; i++) {
                        let room_list = typeList[i].room_list

                        for (let j = 0; j < room_list.length; j++) {
                            let roomDetailList = typeList[i].room_list[j].room_detail_list

                            for (let k = 0; k < roomDetailList.length; k++) {
                                roomDetailList[k].startNum = roomDetailList[k].check_in_start_day.slice(8) // 截取开始的日期
                                roomDetailList[k].endNum = roomDetailList[k].check_in_end_day.slice(8) // 截取结束的日期
                                roomDetailList[k].isOneDay = roomDetailList[k].startNum == roomDetailList[k].endNum ? true : false

                                switch (roomDetailList[k].check_in_status) {
                                    case 1:
                                        roomDetailList[k].className = 'yyd'
                                        break;
                                    case 2:
                                        roomDetailList[k].className = 'yrz'
                                        break;
                                    case 3:
                                        roomDetailList[k].className = 'ycs'
                                        break;
                                    case 4:
                                        roomDetailList[k].className = 'kdzc'
                                        break;
                                    default:
                                        roomDetailList[k].className = 'kf'
                                }
                            }
                        }
                    }

                    setRoomStateData(typeList)
                }
            }
        })
    }

    const resetForm = () => {
        setFetchOtherParams(fetchOtherParamsTmpl)
    }

    return (<div className="common-page">
        {/* 管家中心 -> 入住管理 -> 门店房态图 */}
        <BreadCrumb position={['管家中心', '门店房态图']} />

        <div className="common-top-form">
            <Space direction="horizontal" wrap>
                <div className="fl" style={{ marginRight: 8, marginBottom: 12 }}>
                    <SelectStores value={fetchOtherParams.store_id} onChange={(v: string) => {
                        handleChange(v, 'store_id')

                        if (v) {
                            // 查询房型
                            baseAxiosNoInfo('/global/room_type_list_by_store', {
                                params: {
                                    store_id: v
                                }
                            }).then((res: any) => {
                                res && setRoomTypeList(res)
                            })

                            // 查询朝向
                            baseAxiosNoInfo('/global/room_direction_list_by_store', {
                                params: {
                                    store_id: v
                                }
                            }).then((res: any) => {
                                res && setRoomWays(res)
                            })

                        } else {
                            setRoomTypeList([])
                            setRoomWays([])
                        }
                    }} />
                </div>

                <RangePicker
                    picker="month"
                    className="fl"
                    style={{ marginRight: 8, marginBottom: 12, width: 200 }}
                    value={fetchOtherParams.date}
                    onChange={(v: any) => {
                        if (v) {
                            // 验证日期是否为三个月内
                            let num = getDistanceMonth(moment(v[0]).format('YYYY-MM-DD'), moment(v[1]).format('YYYY-MM-DD'))

                            if (num == 3) {
                                handleChange(v, 'date')

                            } else {
                                return message.error('请选择连续三个月的日期')
                            }

                        } else {
                            handleChange(v, 'date')
                        }
                    }}
                />
                <Input className="fl" style={{ marginRight: 8, marginBottom: 12, width: '120px' }} placeholder="入住人姓名" onChange={(e: { target: { value: string } }) => { handleChange(e.target.value, 'check_in_user_name') }} value={fetchOtherParams.check_in_user_name} />
                <Input className="fl" style={{ marginRight: 8, marginBottom: 12, width: '120px' }} placeholder="入住人手机号" onChange={(e: { target: { value: string } }) => { handleChange(e.target.value, 'check_in_phone') }} value={fetchOtherParams.check_in_phone} />
                {/* 房间房型 */}
                <Select virtual={false} className="fl" style={{ marginRight: 8, marginBottom: 12, width: 140 }} placeholder="房型" onChange={(e: string) => { handleChange(e, 'room_type_id') }} value={fetchOtherParams.room_type_id} >
                    {roomTypeList.map((el: { room_type_id: string, room_type_name: string }) => <Option value={el.room_type_id} key={el.room_type_id}>{el.room_type_name}</Option>)}
                </Select>
                <Input className="fl" style={{ marginRight: 8, marginBottom: 12, width: '120px' }} placeholder="房号" onChange={(e: { target: { value: string } }) => { handleChange(e.target.value, 'room_number') }} value={fetchOtherParams.room_number} />
                <Input className="fl" style={{ marginRight: 8, marginBottom: 12, width: '120px' }} placeholder="楼层" onChange={(e: { target: { value: string } }) => { handleChange(e.target.value, 'floor') }} value={fetchOtherParams.floor} />
                {/* 房间朝向 */}
                {/*
                <Select virtual={false} className="fl" style={{ width: 140, marginRight: 12 }} placeholder="朝向" onChange={(e: number) => { handleChange(e, 'direction') }} value={fetchOtherParams.direction}  >
                    {roomWays.map((el: any) => <Option key={el.direction} value={el.direction}>{el.direction_name}</Option>)}
                </Select>
                */}

                <Button style={{ marginRight: 5, marginBottom: 12 }} className="search-btn fl" icon={<SearchOutlined />} onClick={handleSearch2}>查询</Button>
                <Button className="fl" style={{ marginRight: 5, marginBottom: 12 }} onClick={resetForm} icon={<RedoOutlined />}>重置</Button>
            </Space>
        </div>

        <div className="common-main room-data-cont">
            <div className="clear types">
                <div className="fl clear" style={{ paddingLeft: '16px' }}>
                    <div className="fl" style={{ marginRight: 30, marginTop: 5 }}>
                        <div className="secs fl" style={{ marginRight: 4, width: 20, height: 20, background: '#fff', border: '1px solid hwb(216deg 83% 13%)' }}></div>
                        <span className="fl">空房</span>
                    </div>
                    <div className="fl" style={{ marginRight: 30, marginTop: 5 }}>
                        <div className="secs fl yyd" style={{ marginRight: 4, width: 20, height: 20 }}></div>
                        <span className="fl">已预订</span>
                    </div>
                    <div className="fl" style={{ marginRight: 30, marginTop: 5 }}>
                        <div className="secs fl yrz" style={{ marginRight: 4, width: 20, height: 20 }}></div>
                        <span className="fl">已入住</span>
                    </div>
                    <div className="fl" style={{ marginRight: 30, marginTop: 5 }}>
                        <div className="secs fl ycs" style={{ marginRight: 4, width: 20, height: 20 }}></div>
                        <span className="fl">已出所</span>
                    </div>
                    <div className="fl" style={{ marginRight: 30, marginTop: 5 }}>
                        <div className="secs fl kdzc" style={{ marginRight: 4, width: 20, height: 20 }}></div>
                        <span className="fl">跨店转出</span>
                    </div>
                </div>
            </div>

            {/* 主体内容 */}
            {(columnsList && columnsList.length > 0) && (
                <div className="container">
                    <div className="top-header" style={{ width: `${100 * columnsList.length}px` }}>
                        <span className="top-left">房间房型</span>
                        <div className="top-date-box" style={{ width: `${100 * columnsList.length}px` }}>
                            {
                                columnsList.map((room: any) => {
                                    return <div className="top-date" key={room.render_date}>
                                        <div>{room.render_date}</div>
                                        <div>{room.render_date_week}</div>
                                    </div>
                                })
                            }
                        </div>
                    </div>

                    <div className="center-body">
                        {
                            roomStateData.map((el: any) => {
                                return (
                                    <div className="body-box" style={{ width: `${(100 * columnsList.length) + 100}px` }} key={el.room_type_id}>
                                        <div className="body-line body-line-title body-line-item">
                                            <div className="body-line-text item-text">{el.room_type_name}</div>
                                        </div>
                                        {
                                            el.room_list.map((el2: any) => {
                                                return (
                                                    <div className="body-line-main body-line-item" key={el2.room_id}>
                                                        <div className="body-line-num item-text">{el2.room_number}</div>
                                                        {el2.room_detail_list.map((el3: any, index3: any) =>
                                                            <div
                                                                key={index3}
                                                                style={{
                                                                    width: (el3.check_in_days) * 100,
                                                                    height: '60px',
                                                                    lineHeight: '60px',
                                                                    left: ((el3.date_index) * 100) + 100,
                                                                    borderBottom: '1px solid #d4dbe3'
                                                                }}
                                                                className={"user-room-data fl " + el3.className}
                                                                title={el3.check_in_user_name}
                                                            >
                                                                {el3.check_in_user_name}
                                                            </div>)
                                                        }
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
            )}
            {/* 主体内容 */}
        </div>
    </div>)
}